import { ActionType } from "../contants/action-types"

export const getSMSC = (smsc) => {
    return{
        type:ActionType.GET_SMSC_LIST,
        payload : smsc
    }
} 